/* eslint-disable jsx-a11y/anchor-is-valid */
import { Form, Modal, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Link } from "react-router-dom";
import { Action, ActionType, Brand, BrandUI } from "../../entity/brand.model";
import { brandService } from "../../service/brand.service";
import { mConstants } from "../../../../../helper/constants";

export interface BrandTableProps {
  data: Brand[];
  onReload: () => void;
}

export default function BrandTable(props: BrandTableProps) {
  const customerTableColumns: ColumnsType<BrandUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    // {
    //   title: "UUID",
    //   dataIndex: "brand1Cuuid",
    //   key: "brand1Cuuid",
    // },
    {
      title: "Нэр",
      dataIndex: "brand1Cname",
      key: "brand1Cname",
    },
    {
      title: "Зураг",
      dataIndex: "imagePath",
      key: "imagePath",
      render: (imagePath: string) => (
        <img
          src={
            mConstants.API_URL +
            mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
            imagePath
          }
          alt="Брэнд зураг"
          style={{ width: "50px" }}
        />
      ),
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: BrandUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      key={`action-${record.uuid}`}
                      to={`/brand/${record.uuid}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                } else if (action.type === ActionType.delete) {
                  return (
                    <a
                      key={`delete-action-${record.uuid}`}
                      href="#"
                      className="dropdown-item"
                      onClick={() => {
                        Modal.confirm({
                          title: "Баталгаажуулах",
                          content: `Та устгахдаа итгэлтэй байна уу?`,
                          okText: "Үргэлжлүүлэх",
                          cancelText: "Хаах",
                          onOk: () => {
                            brandService
                              .deleteBrand(record.uuid!)
                              .then(() => {
                                Modal.success({
                                  title: "Амжилттай",
                                  content: "Брэнд амжилттай устлаа.",
                                });
                                props.onReload();
                              })
                              .catch((e) => console.error(e));
                          },
                        });
                      }}
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </a>
                  );
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];
  const brandUIs: BrandUI[] = props.data.map((brand, index) => {
    const actions: Action[] = [
      { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      { icon: "icon-trash", text: "Устгах", type: ActionType.delete },
    ];
    return {
      ...brand,
      actions: actions,
      index: index + 1,
      key: index,
    };
  });

  return (
    <Table
      className="table table-responsive"
      columns={customerTableColumns}
      dataSource={brandUIs}
      pagination={false}
    />
  );
}
